export default "__VITE_ASSET__C$J3qIdC__"